/**
 * Atributos fijos del producto (iconos en carta + selección en dashboard).
 * Los ids se persisten en product.attributes: string[].
 */
import {
  Bone,
  ChefHat,
  EggOff,
  Fish,
  Flame,
  LeafyGreen,
  MilkOff,
  Nut,
  Vegan,
  WheatOff,
} from 'lucide-react';

export const PRODUCT_ATTRIBUTES = [
  { id: 'vegan', label: 'Vegano', description: 'Sin ingredientes de origen animal', Icon: Vegan },
  { id: 'vegetarian', label: 'Vegetariano', description: 'Sin carne ni pescado', Icon: LeafyGreen },
  { id: 'spicy', label: 'Picante', description: 'Contiene ají o especias picantes', Icon: Flame },
  { id: 'chefs_pick', label: 'Del chef', description: 'Recomendación de la casa', Icon: ChefHat },
  { id: 'with_bone', label: 'Con hueso', description: 'Se sirve con hueso', Icon: Bone },
  { id: 'gluten_free', label: 'Sin gluten', description: 'Elaborado sin gluten', Icon: WheatOff },
  { id: 'dairy_free', label: 'Sin lácteos', description: 'Sin leche ni derivados', Icon: MilkOff },
  { id: 'contains_nuts', label: 'Frutos secos', description: 'Contiene o puede contener frutos secos', Icon: Nut },
  { id: 'egg_free', label: 'Sin huevo', description: 'Elaborado sin huevo', Icon: EggOff },
  { id: 'seafood', label: 'Mariscos', description: 'Contiene pescado o mariscos', Icon: Fish },
];

const ATTRIBUTE_BY_ID = Object.fromEntries(PRODUCT_ATTRIBUTES.map((a) => [a.id, a]));
const ALLOWED_IDS = new Set(PRODUCT_ATTRIBUTES.map((a) => a.id));

export function getProductAttribute(id) {
  return ATTRIBUTE_BY_ID[id] || null;
}

/** Filtra a ids válidos y únicos, preservando orden del catálogo. */
export function normalizeProductAttributes(raw) {
  if (!Array.isArray(raw)) return [];
  const selected = new Set(
    raw.map((x) => String(x ?? '').trim()).filter((id) => ALLOWED_IDS.has(id)),
  );
  return PRODUCT_ATTRIBUTES.filter((a) => selected.has(a.id)).map((a) => a.id);
}

export function resolveProductAttributes(raw) {
  return normalizeProductAttributes(raw)
    .map((id) => ATTRIBUTE_BY_ID[id])
    .filter(Boolean);
}

export function toggleProductAttribute(current, id) {
  if (!ALLOWED_IDS.has(id)) return normalizeProductAttributes(current);
  const set = new Set(normalizeProductAttributes(current));
  if (set.has(id)) set.delete(id);
  else set.add(id);
  return PRODUCT_ATTRIBUTES.filter((a) => set.has(a.id)).map((a) => a.id);
}
